/**
 * 车辆服务
 * @author xingzb
 * @date 2020-03-13
 */
import request from '@/utils/request'

export function vehicleInsurance(query) {
  return request({
    url: '/ntocc-basic-api/vehicleInsurance',
    method: 'get',
    params: query
  })
}

export function delVehicleInsurance(query) {
  return request({
    url: '/ntocc-basic-api/vehicleInsurance',
    method: 'delete',
    params: query
  })
}

export function addVehicleInsurance(query) {
  return request({
    url: '/ntocc-basic-api/vehicleInsurance',
    method: 'post',
    params: query
  })
}

export function vehicleInsuranceCode(code) {
  return request({
    url: `/ntocc-basic-api/vehicleInsurance/${code}`,
    method: 'get'
  })
}

export function updateVehicleInsurance(query) {
  return request({
    url: '/ntocc-basic-api/vehicleInsurance',
    method: 'put',
    params: query
  })
}

export function vehicleRepair(query) {
  return request({
    url: '/ntocc-basic-api/vehicleRepair',
    method: 'get',
    params: query
  })
}

export function delVehicleRepair(query) {
  return request({
    url: '/ntocc-basic-api/vehicleRepair',
    method: 'delete',
    params: query
  })
}

export function addVehicleRepair(data) {
  return request({
    url: '/ntocc-basic-api/vehicleRepair',
    method: 'post',
    data
  })
}

export function vehicleRepairCode(code) {
  return request({
    url: `/ntocc-basic-api/vehicleRepair/${code}`,
    method: 'get'
  })
}

export function updateVehicleRepair(data) {
  return request({
    url: '/ntocc-basic-api/vehicleRepair',
    method: 'put',
    data
  })
}

export function vehicleViolation(query) {
  return request({
    url: '/ntocc-basic-api/vehicleViolation',
    method: 'get',
    params: query
  })
}

export function vehicleViolationCode(query) {
  return request({
    url: `/ntocc-basic-api/vehicleViolation/detailList/`,
    method: 'get',
    params: query
  })
}

export function vehicleAccident(query) {
  return request({
    url: '/ntocc-basic-api/vehicleAccident',
    method: 'get',
    params: query
  })
}

export function delVehicleAccident(query) {
  return request({
    url: '/ntocc-basic-api/vehicleAccident',
    method: 'delete',
    params: query
  })
}

export function addVehicleAccident(data) {
  return request({
    url: '/ntocc-basic-api/vehicleAccident',
    method: 'post',
    data
  })
}

export function vehicleAccidentCode(code) {
  return request({
    url: `/ntocc-basic-api/vehicleAccident/${code}`,
    method: 'get'
  })
}

export function updateVehicleAccident(data) {
  return request({
    url: `/ntocc-basic-api/vehicleAccident`,
    method: 'put',
    data
  })
}
// 添加车辆违章记录
export function vehicleViolationAdd(data) {
  return request({
    url: `/ntocc-basic-api/vehicleViolation`,
    method: 'post',
    data
  })
}
// 车辆违章记录详情
export function vehicleViolationDetail(code) {
  return request({
    url: `/ntocc-basic-api/vehicleViolation/${code}`,
    method: 'get'
  })
}
// 编辑车辆违章记录
export function vehicleViolationEdit(data) {
  return request({
    url: `/ntocc-basic-api/vehicleViolation`,
    method: 'put',
    data
  })
}
// 删除车辆违章记录
export function vehicleViolationDelete(query) {
  return request({
    url: `/ntocc-basic-api/vehicleViolation`,
    method: 'delete',
    params: query
  })
}

/*
* 车辆规定费用表 列表
* xueli
* 2020年4月29日10:39:55
* */
export function ctmsVehiclePrescribeFee(query) {
  return request({
    url: `/ntocc-basic-api/ctmsVehiclePrescribeFee`,
    method: 'get',
    params: query
  })
}

/*
* 删除车辆规定费用表
* xueli
* 2020年4月29日10:40:54
* */
export function delCtmsVehiclePrescribeFee(query) {
  return request({
    url: '/ntocc-basic-api/ctmsVehiclePrescribeFee',
    method: 'delete',
    params: query
  })
}

/*
* 添加车辆规定费用表
* xueli
* 2020年4月29日10:40:59
* */
export function addctmsVehiclePrescribeFee(query) {
  return request({
    url: '/ntocc-basic-api/ctmsVehiclePrescribeFee',
    method: 'post',
    params: query
  })
}

/*
* 更新车辆规定费用表
* xueli
* 2020年4月29日10:41:32
*  */
export function updateCtmsVehiclePrescribeFee(query) {
  return request({
    url: `/ntocc-basic-api/ctmsVehiclePrescribeFee`,
    method: 'put',
    params: query
  })
}

/*
* 车辆加油 列表
* xueli
* 2020年4月29日 17:44:22
* */
export function ctmsVehicleOil(query) {
  return request({
    url: `/ntocc-basic-api/ctmsVehicleOil`,
    method: 'get',
    params: query
  })
}

/*
* 删除车辆加油表
* xueli
* 2020年4月29日 17:46:08
* */
export function delCtmsVehicleOil(codes) {
  return request({
    url: '/ntocc-basic-api/ctmsVehicleOil',
    method: 'delete',
    params: codes
  })
}

/*
* 添加车辆加油表
* xueli
* 2020年4月29日10:40:59
* */
export function addCtmsVehicleOil(query) {
  return request({
    url: '/ntocc-basic-api/ctmsVehicleOil',
    method: 'post',
    params: query
  })
}

/*
* 更新车辆加油表
* xueli
* 2020年4月29日10:41:32
*  */
export function updateCtmsVehicleOil(query) {
  return request({
    url: `/ntocc-basic-api/ctmsVehicleOil`,
    method: 'put',
    params: query
  })
}
